import React from 'react';
import { AlertCircle } from 'lucide-react';

const Maintenance = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 flex items-center justify-center">
      <div className="bg-white rounded-2xl shadow-2xl p-12 max-w-md text-center mx-4">
        <div className="w-20 h-20 mx-auto mb-6 bg-amber-100 rounded-full flex items-center justify-center">
          <AlertCircle className="w-10 h-10 text-amber-600" />
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Under Maintenance</h1>
        <p className="text-gray-600 mb-6">
          We're making some improvements. Please check back in a few minutes.
        </p>
        <p className="text-sm text-gray-500">
          Thank you for your patience! 🛠️
        </p>
      </div>
    </div>
  );
};

export default Maintenance;